






































































































































































import { RootState } from "@/store";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

// Vue components
import DeviceFolderTree from "@/components/DeviceFolderTree.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ServiceResponseData } from "@/model/communication/ServiceResponseData";
import { CreateClientProfileCommand } from "@/model/communication/users/CreateClientProfileCommand";
import { CreateClientProfileReqData } from "@/model/communication/users/CreateClientProfileReqData";
import { FetchWindowsGroupsCommand } from "@/model/communication/users/FetchWindowsGroupsCommand";
import { GetAnyAuthPluginCommand } from "@/model/communication/users/GetAnyAuthPluginCommand";
import { UpdateClientProfileCommand } from "@/model/communication/users/UpdateClientProfileCommand";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { ClientProfile } from "@/model/data/authentication/ClientProfile";
import { LicenseData } from "@/model/data/License/LicenseData";
import { defaultLicenseModuleEnumSorting, getLicenseModuleLabel, LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { LoginMode, LoginModeType } from "@/model/data/organizations/LoginMode";
import { Organization } from "@/model/data/organizations/Organization";
import Privileges, { SinglePrivilege } from "@/utility/UserPrivileges";
import { getLicenseModuleIconColor } from "@/utility/Constants";

export default Vue.extend({
    components: {
        DeviceFolderTree,
    },
    data() {
        return {
            LoginModeType,
            profileNameMaxLength: 58,
            profileNameInternalString: "@$",
            profileName: "",
            windowsGroup: "",
            authPluginGroup: "",
            selectedPrivileges: [],
            selectedFolders: [],
            errorMessage: "",
            windowsGroupsLoading: false,
            availableWindowsGroups: [],
            showAuthPluginGroupInput: false,
            azureGroup: "",
            wsFedProfile: "",

            selectedOrganization: null,
            saving: false,
        };
    },
    props: {
        clientProfile: ClientProfile,
        availableOrganizations: { type: Array as () => Organization[], default: [] },
    },
    computed: {
        ...mapState({
            licenseData: (state: RootState) => state.license.licenseModules,
            startupData: (state: RootState) => state.application.startupData,
            authUser: (state: RootState) => state.authMod.currentUser,
        }),

        ...mapGetters(["isUserSuperAdmin"]),

        isUserSuperAdminComp() {
            return this.isUserSuperAdmin;
        },

        isWSFedAuthenticationEnabledComp() {
            return this.startupData.isWSFedAuthenticationEnabled;
        },

        isOrganizationManagementEnabled() {
            if (
                this.authUser != null &&
                this.authUser.profile != null &&
                this.authUser.profile.privileges != null &&
                this.authUser.profile.privileges.privilegeName != null &&
                this.authUser.profile.privileges.privilegeName.includes(ClientPrivileges.OrganizationsManagement.privilegeName)
            )
                return true;
            else return false;
        },

        canSave(): boolean {
            if (this.profileName == null || this.profileName.length == 0 || this.profileName.length > this.profileNameMaxLength) return false;
            if (this.selectedFolders == null || this.selectedFolders.length == 0) return false;
            if (this.selectedPrivileges == null || this.selectedPrivileges.length == 0 || this.selectedPrivileges.map((p) => p.privileges).flat().length == 0) return false;
            return true;
        },

        availableLicenseModules() {
            let res = this.defaultLicenseModuleEnumSorting();
            res = res.filter((v) => this.licenseData.modules.map((m) => m.module).includes(v));
            res.push(LicenseModuleEnum.None);
            // filtro in base ai privilegi del profilo dell'utente loggato
            res = res.filter((l) => this.availablePrivilegesForThisProfile.map((p) => p.requiredLicense).includes(l));
            return res;
        },

        availablePrivilegesForThisProfile(): SinglePrivilege[] {
            let res: SinglePrivilege[];
            // filtro per moduli di licenza (sul cloud comunque ci sono tutti)
            res = Privileges.filter((v) => (this.licenseData as LicenseData).isAvailable(v.requiredLicense));
            // privilegi esclusi dall'UI
            res = res.filter((v) => v.name != ClientPrivileges.None && v.name != ClientPrivileges.SuperAdmin);
            // un utente può associare a un profilo un subset dei privilegi (o tutti) associati al profilo a cui esso appartiene (tranne il super admin)
            if (
                this.authUser != null &&
                this.authUser.profile != null &&
                this.authUser.profile.privileges != null &&
                this.authUser.profile.privileges.privilegeName != null &&
                !this.isUserSuperAdminComp
            )
                res = res.filter((p) => this.authUser.profile.privileges.privilegeName.includes(p.name));

            // ordino in ordine alfabetico
            res.sort((a, b) => {
                if (this.$t(a.namei18n) < this.$t(b.namei18n)) return -1;
                if (this.$t(a.namei18n) > this.$t(b.namei18n)) return 1;
                return 0;
            });
            return res;
        },

        profileOrganization() {
            let res = null;
            if (this.selectedOrganization != null && this.availableOrganizations != null && this.availableOrganizations.length > 0)
                if (this.availableOrganizations.some((o) => o.id == this.selectedOrganization.value))
                    res = this.availableOrganizations.filter((o) => o.id == this.selectedOrganization.value)[0];
            return res;
        },

        selectedPrivilegesLength() {
            let res = [];
            this.availableLicenseModules.forEach((availableLicenseModule) => {
                res.push({ licenseModule: availableLicenseModule, length: 0 });
            });

            this.selectedPrivileges.forEach((selectedPrivilegesSingleModule) => {
                res.find((s) => s.licenseModule == selectedPrivilegesSingleModule.licenseModule).length += selectedPrivilegesSingleModule.privileges.length;
            });

            return res;
        },
    },
    watch: {
        clientProfile(newValue) {
            this.reset(newValue);
        },

        selectedOrganization(newValue) {
            console.log("selectedOrganization changed", newValue);
            this.availableWindowsGroups = [];
            if (newValue != null && this.availableOrganizations.some((o) => o.id == newValue.value)) {
                let tempOrganization = this.availableOrganizations.filter((o) => o.id == newValue.value)[0];
                let tempLoginModes = tempOrganization.loginModes;
                if (tempLoginModes != null && tempLoginModes.some((l) => l.enabled)) {
                    tempLoginModes
                        .filter((l) => l.enabled)
                        .forEach(async (loginMode: LoginMode) => {
                            switch (loginMode.type) {
                                case LoginModeType.ADLegacy:
                                    console.log("Try to get the Windoes groups for the organization: ", tempOrganization);
                                    await this.getWindowsGroups();
                                    break;
                                default:
                                    break;
                            }
                        });
                }
            }
        },
    },
    methods: {
        getLicenseModuleLabel,
        defaultLicenseModuleEnumSorting,
        getLicenseModuleIconColor,

        unselectAllPrivileges(licenseModule: LicenseModuleEnum) {
            if (licenseModule == null) {
                this.selectedPrivileges = [];
                this.availableLicenseModules.forEach((element) => {
                    this.selectedPrivileges.push({ licenseModule: element, privileges: [] });
                });
            } else if (this.selectedPrivileges.some((p) => p.licenseModule == licenseModule)) this.selectedPrivileges.find((p) => p.licenseModule == licenseModule).privileges = [];
        },

        selectAllPrivileges(licenseModule: LicenseModuleEnum) {
            if (licenseModule == null) {
                this.selectedPrivileges = [];
                this.availableLicenseModules.forEach((element) => {
                    this.selectedPrivileges.push({ licenseModule: element, privileges: [] });
                });
                this.availablePrivilegesForThisProfile.forEach((availablePrivilegeForThisProfile) => {
                    this.selectedPrivileges
                        .find((s) => s.licenseModule == availablePrivilegeForThisProfile.requiredLicense)
                        .privileges.push(availablePrivilegeForThisProfile.name.privilegeName);
                });
            } else if (this.selectedPrivileges.some((p) => p.licenseModule == licenseModule))
                this.selectedPrivileges.find((p) => p.licenseModule == licenseModule).privileges = this.availablePrivilegesForThisProfile
                    .filter((p) => p.requiredLicense == licenseModule)
                    .map((p) => p.name.privilegeName);
        },

        onCloseClick() {
            this.reset(null);
            this.$emit("close");
        },

        async getWindowsGroups() {
            try {
                if (!this.windowsGroupsLoading) {
                    this.windowsGroupsLoading = true;
                    const res = await new FetchWindowsGroupsCommand().execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        if (res.groups != null && res.groups.length > 0) {
                            this.availableWindowsGroups = [];
                            res.groups.forEach((group) => {
                                this.availableWindowsGroups.push(group);
                            });
                        }
                    }
                    this.windowsGroupsLoading = false;
                }
            } catch (error) {
                console.log("Something went wrong during FetchWindowsGroupsCommand execution: ", error);
                this.windowsGroupsLoading = false;
            }
        },

        async getAnyAuthPlugin() {
            try {
                // check if any authplugin group
                new GetAnyAuthPluginCommand().execute().then((res) => {
                    this.showAuthPluginGroupInput = res.any;
                });
            } catch (error) {
                console.log("Something went wrong during GetAnyAuthPluginCommand execution: ", error);
            }
        },

        async reset(profile: ClientProfile) {
            this.profileName = "";
            this.windowsGroup = "";
            this.azureGroup = "";
            this.wsFedProfile = "";
            this.authPluginGroup = "";
            this.availableWindowsGroups = [];
            this.showAuthPluginGroupInput = false;

            this.errorMessage = "";
            this.selectedFolders = [];
            this.selectedOrganization = null;

            this.selectedPrivileges = [];
            this.availableLicenseModules.forEach((element) => {
                this.selectedPrivileges.push({ licenseModule: element, privileges: [] });
            });

            await this.getAnyAuthPlugin();

            if (profile != null) {
                this.profileName = profile.name;

                // Profile organization
                if (profile.organizationId != null)
                    this.selectedOrganization = this.availableOrganizations.map((o) => ({ text: o.name, value: o.id })).filter((o) => o.value == profile.organizationId)[0];

                // SSO login
                this.windowsGroup = profile.windowsGroup;
                if (this.startupData != null && this.isWSFedAuthenticationEnabledComp) {
                    this.wsFedProfile = profile.windowsGroup;
                    this.windowsGroup = "";
                } else if (
                    (this.startupData != null && this.startupData.azureADLoginEnabled) ||
                    (this.profileOrganization != null &&
                        this.profileOrganization.loginModes != null &&
                        this.profileOrganization.loginModes.some((l) => l.type == LoginModeType.AzureAD && l.enabled))
                ) {
                    this.azureGroup = profile.windowsGroup;
                    this.windowsGroup = "";
                }
                this.authPluginGroup = profile.authPluginGroup;

                // Preselect privileges
                try {
                    this.availablePrivilegesForThisProfile.forEach((availablePrivilegeForThisProfile) => {
                        if (profile.privileges.privilegeName.includes(availablePrivilegeForThisProfile.name))
                            this.selectedPrivileges
                                .find((s) => s.licenseModule == availablePrivilegeForThisProfile.requiredLicense)
                                .privileges.push(availablePrivilegeForThisProfile.name.privilegeName);
                    });
                } catch {
                    this.selectedPrivileges = [];
                    this.availableLicenseModules.forEach((element) => {
                        this.selectedPrivileges.push({ licenseModule: element, privileges: [] });
                    });
                }

                // Folders visibility
                if (profile.associatedHierarchyList != null && profile.associatedHierarchyList.length > 0) this.selectedFolders = profile.associatedHierarchyList.map((c) => c.id);
                else this.selectedFolders = [];
            }
        },

        async onSaveClick() {
            if (this.canSave && !this.saving) {
                try {
                    this.saving = true;

                    const reqData = new CreateClientProfileReqData();
                    reqData.name = this.profileName;
                    reqData.organizationId = null;
                    if (this.selectedOrganization != null) reqData.organizationId = this.selectedOrganization.value;
                    reqData.privileges = new ClientPrivileges(
                        this.selectedPrivileges
                            .map((p) => p.privileges)
                            .flat()
                            .join(",")
                    );
                    if (this.windowsGroup != null && this.windowsGroup.length > 0) reqData.windowsGroup = this.windowsGroup;
                    else if (this.azureGroup != null && this.azureGroup.length > 0) reqData.windowsGroup = this.azureGroup;
                    else reqData.windowsGroup = this.wsFedProfile;

                    reqData.authPluginGroup = this.authPluginGroup;
                    reqData.associatedFoldersIds = this.selectedFolders;

                    let res: ServiceResponseData;
                    if (this.clientProfile != null) res = await new UpdateClientProfileCommand(reqData).execute();
                    else res = await new CreateClientProfileCommand(reqData).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success) this.onCloseClick();
                    else this.errorMessage = this.$t("user_management.error_editing", this.profileName);

                    this.saving = false;
                } catch (error) {
                    console.log("Something went wrong during CreateClientProfileCommand or UpdateClientProfileCommand execution: ", error);
                    this.saving = false;
                }
            }
        },
    },
    mounted() {
        this.reset(this.clientProfile);
    },
});
